import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const updateTemplateApi = createAsyncThunk("updateTemplate", async (formData) => {
    const response = await axiosInstance.post(`/updateTemplate/${formData._id}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
});

const updateTemplateSlice = createSlice({
    name: "updateTemplate",
    initialState: {
        updateTemplate: [],
        errors: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateTemplateApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateTemplateApi.fulfilled, (state, action) => {
                state.updateTemplate = action.payload;
                state.loading = false;
            })
            .addCase(updateTemplateApi.rejected, (state, action) => {
                state.errors = action.payload || action.error.message;
                state.loading = false;
            });
    },
});

export default updateTemplateSlice.reducer;
